/* global leagueAverageDataFilteredGrouped, serverParams */
import Table from 'bam-node-savant-table/table'
import { guff } from 'bam-node-baseball-savant/utils/guff'

import 'bam-node-baseball-savant/leaderboard/utils/multi-select'
import concatGroupedHeaders from '../../utils/concat-grouped-headers'
import getGroupedHeaders from '../../utils/get-grouped-headers'
import getDynamicAggregateFirstHeaders from '../../utils/dynamic-aggregate-first-headers'

const tableDivId = 'pitcher_arm_angle_table'

const link = '?stats=statcast-r-pitching-mlb#arm_angles'
const firstHeaders = getDynamicAggregateFirstHeaders(serverParams.type, link)

const standardHeaders = [
    ...firstHeaders,
    {
        name: 'Pitch<br/>Hand',
        field: 'pitch_hand',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data`,
    },
    {
        name: 'Pitches',
        field: 'n_pitches',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data`,
        type: 'number',
        displayFn: (val) => val.toLocaleString(),
    },
    {
        name: 'Arm Angle',
        field: 'arm_angle',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data`,
        type: 'number',
        displayFn: (val) => `${guff(val, 'arm_angle')}°`,
    },
    // Ball Release
    {
        name: 'X Dist. from<br/> Center of Mound',
        field: 'release_ball_x',
        headerClass: `th-component-header align-center th-vertical-bottom border-left`,
        fieldClass: `tr-data border-left`,
        type: 'number',
        displayFn: (val) => val.toFixed(2),
        toolTip:
            'Negative numbers are towards 3rd base, positive numbers towards 1st base. Zero is at the center of the mound.',
    },
    {
        name: 'X Dist. from <br/>Center of Mass',
        field: 'relative_release_ball_x',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data`,
        type: 'number',
        displayFn: (val) => val.toFixed(2),
        toolTip:
            "Negative numbers are towards 3rd base, positive numbera are towards 1st base. Zero is at the player's center of mass.",
    },
    {
        name: 'Height',
        field: 'release_ball_z',
        headerClass: `th-component-header align-center th-vertical-bottom`,
        fieldClass: `tr-data`,
        type: 'number',
        displayFn: (val) => val.toFixed(2),
    },
    // Shoulder
    {
        name: 'X Dist. from<br/> center of mound',
        field: 'relative_shoulder_x',
        headerClass: `th-component-header align-center th-vertical-bottom border-left`,
        fieldClass: `tr-data border-left`,
        type: 'number',
        displayFn: (val) => val.toFixed(2),
        toolTip:
            'Negative numbers are towards 3rd base, positive numbera are towards 1st base. Zero is at the center of the mound.',
    },
    {
        name: 'Height',
        field: 'shoulder_z',
        headerClass: `th-component-header align-center th-vertical-bottom border-right`,
        fieldClass: `tr-data border-right`,
        type: 'number',
        displayFn: (val) => val.toFixed(2),
    },
]

const groupHeaders = getGroupedHeaders(serverParams.secondaryGroupBy)

const headers = concatGroupedHeaders(
    standardHeaders,
    groupHeaders,
    'pitch_hand'
)

const ballIdx = headers.findIndex((d) => d.field === 'release_ball_x')

const secondaryHeaders = [
    {
        name: '',
        colspan: ballIdx + 1,
        headerClass: 'th-name-header',
    },
    {
        name: 'Ball Position at Release (ft)',
        colspan: 3,
        headerClass: 'th-secondary-em border-bottom border-right',
    },
    {
        name: 'Shoulder Position at Release (ft)',
        colspan: 2,
        headerClass: 'th-secondary-em border-bottom',
    },
]

export const $tableDiv = document.getElementById(tableDivId)

export default function loadPitcherArmAngleTable(
    data,
    showLeagueAverage = false,
    existingSort = null,
    existingSortDir = null
) {
    if (showLeagueAverage) {
        // eslint-disable-next-line no-param-reassign
        data = [
            ...data,
            ...leagueAverageDataFilteredGrouped.map((d) => ({
                ...d,
                pinned: true,
            })),
        ]
    }
    $tableDiv.innerHTML = ''

    const currentParams = new URLSearchParams(window.location.search)
    const defaultSort =
        existingSort || currentParams.get('sortColumn') || 'arm_angle'
    const defaultSortDirection =
        existingSortDir || currentParams.get('sortDirection') || 'asc'

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        data,
        // headers: [...headers, ...groupHeaders],
        hasPinned: true,
        headers,
        sortClass: 'column-sort',
        secondaryHeaders,
        showRank: true,
        defaultSort,
        defaultSortDirection,
        sortCallback(column, _, { state }) {
            const url = new URL(window.location)
            url.searchParams.set('sortColumn', column)
            url.searchParams.set('sortDirection', state)
            window.history.replaceState('', '', url.toString())
        },
    })
}
